import React from "react";
import MaterialIcon from "./MaterialIcon";
import IconInterface from "./IconInterface";

export default class MaterialToggleIcon implements IconInterface
{
    private icon: string;
    private activeIcon: string;

    constructor(icon: string, activeIcon: string) {
        this.icon = icon;
        this.activeIcon = activeIcon;
    }

    get(active: boolean = false): React.ReactNode {
        if (active) {
            return new MaterialIcon(this.activeIcon).get()
        }
        return new MaterialIcon(this.icon).get()
    }
}